import { DragHandle } from '@mui/icons-material'
import { Typography } from '@mui/material'
import React from 'react'

const DragAndDropInstructions = (props) => {
  return (
    <Typography
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center',
        ...props.sx,
      }}
    >
      {'The order of these fields can be arranged clicking and dragging the'
        .split(' ')
        .map((t) => (
          <span>{t}&nbsp;</span>
        ))}
      <DragHandle sx={{ mx: '2px' }} /> <span></span>
      {'icon to the left of each box.'.split(' ').map((t) => (
        <span>{t}&nbsp;</span>
      ))}
    </Typography>
  )
}

export default DragAndDropInstructions
